<template>
	<div class="adverts jt-wrap">
		<search-adverts
			v-on:addAdverts="addAdverts"
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:search="search"
		>
		</search-adverts>
		<add-adverts
			v-on:cancel="cancel"
			:adverts="adverts"
			:dialogAdverts="dialogAdverts"
		></add-adverts>
		<div class="table vue-padding radius" style="overflow: scroll;">
			<el-row
				:gutter="20"
				type="flex"
				justify="start"
				v-if="advertsList.length > 0"
			>
				<el-col
					:xl="4"
					:lg="6"
					:sm="8"
					:xs="24"
					v-for="(item, index) in advertsList"
					:key="index"
				>
					<el-card :body-style="{ padding: '0px' }">
						<div class="content">
							<el-image
								:src="item.url"
								:preview-src-list="imageList"
								v-if="isImageAdvert(item)"
								:fit="fit"
								class="image"
							>
								<div slot="placeholder" class="image-slot">
									{{ $t("common.loading")
									}}<span class="el-icon-loading"></span>
								</div>
							</el-image>
							<video
								:src="item.url"
								v-if="isVideoAdvert(item)"
								:controls="true"
								class="video"
							></video>
							<div class="info" v-show="adHover === item.id">
								<div class="info-container">
									<div class="ad-info">{{ item.userName || "-" }}</div>
									<div class="ad-info">{{ item.nickName || "-" }}</div>
									<div class="ad-info">{{ mediaTypeLabel(item.type) }}</div>
								</div>
							</div>
						</div>
						<div style="padding: 14px;">
							<div
								class="title"
								@mouseover="enter(item.id)"
								@mouseout="leave(item.id)"
							>
								{{ item.head ? item.head : $t("common.noTit") }}
							</div>
							<div class="meta">{{ item.nickName || item.userName || "-" }}</div>
							<div class="bottom clearfix">
								<time class="time">{{ createTime(item.createTime) }}</time>
								<div class="btn-group">
									<span
										class="el-icon-edit"
										v-hasPerm="['adverts:update']"
										@click="editAdverts(item)"
									></span>
									<span
										class="el-icon-delete"
										v-hasPerm="['adverts:delete']"
										@click="delOneAdverts(item)"
									></span>
								</div>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>

			<el-pagination
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				@size-change="sizeChange"
				:page-size="page.pageSize"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import searchAdverts from "_c/adverts/SearchAdverts";
import addAdverts from "_c/adverts/AddAdverts";

const createDefaultAdvert = () => ({
	id: "",
	type: 0,
	url: "",
	head: "",
	userName: "",
	nickName: "",
});

export default {
	name: "Adverts",
	components: {
		searchAdverts,
		addAdverts,
	},
	data() {
		return {
			dialogAdverts: false,
			advertsList: [],
			advertListOne: [],
			advertListTwo: [],
			loading: false,
			page: {
				pageSize: 12,
				pageIndex: 1,
			},
			search: {
				userName: "",
				head: "",
				nickName: "",
			},
			adverts: createDefaultAdvert(),
			selectId: [],
			imageList: [],
			fit: "cover",
			adHover: "",
		};
	},
	mounted() {
		this.currentChange();
	},
	methods: {
		// 添加广告
		addAdverts() {
			this.adverts = createDefaultAdvert();
			this.dialogAdverts = true;
		},

		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},

		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.Adverts.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.advertsList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
						this.imageList = res.data.records
							.filter(item => this.isImageAdvert(item) && item.url)
							.map(item => item.url);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 编辑广告
		editAdverts(row) {
			this.adverts = createDefaultAdvert();
			this.dialogAdverts = true;
			Object.keys(this.adverts).forEach(key => {
				this.adverts[key] = row[key];
			});
			this.adverts.id = row.id;
			this.adverts.type = Number(row.type) === 1 ? 1 : 0;
		},
		// 删除广告
		delAdverts(data) {
			this.$api
				.request(this.$url.Adverts.delete, this.$method.delete, { id: data })
				.then(res => {
					if (res.code === 0) {
						this.$notify({
							title: this.$t("common.tip"),
							message: res.msg,
							type: "success",
						});
						this.currentChange(this.page.pageIndex);
					}
				});
		},

		delOneAdverts(row) {
			this.$confirm(this.$t("adverts.delete"), this.$t("common.warning"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.delAdverts(row.id);
			});
		},
		createTime(createTime) {
			return createTime;
		},
		mediaTypeLabel(type) {
			return Number(type) === 1 ? this.$t("addAdverts.video") : this.$t("addAdverts.image");
		},
		isImageAdvert(advert) {
			return Number(advert && advert.type) === 0;
		},
		isVideoAdvert(advert) {
			return Number(advert && advert.type) === 1;
		},
		cancel(dialog, state) {
			this.dialogAdverts = dialog;
			if (state) {
				this.currentChange(this.page.pageIndex);
			}
		},
		enter(id) {
			this.adHover = id;
		},
		leave() {
			this.adHover = "";
		},
	},
};
</script>

<style lang="scss">
.el-dialog__header {
	padding: 20px;
}

.el-dialog__body {
	padding: 0 20px;
	height: auto !important;
}

.el-dialog__footer {
	padding: 20px;
}

.adverts {
	.image,
	.video {
		width: 100%;
		height: 260px;
	}

	.image {
		cursor: pointer;
	}

	.title {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.meta {
		margin-top: 8px;
		color: #909399;
		font-size: 12px;
		line-height: 1.4;
	}

	.title:hover {
		cursor: pointer;
	}

	.el-card {
		margin: 5px 0;
	}

	.content {
		position: relative;
		overflow: hidden;

		.info {
			position: absolute;
			padding: 20px;
			color: rgba(255, 255, 255, 0.9);
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: rgba(0, 0, 0, 0.6);
		}

		.info-container {
			position: relative;
			top: 50%;
			transform: translateY(-50%);
		}

		.ad-info {
			margin: 10px 0;
			animation: advert;
			animation-duration: 0.3s;
			animation-timing-function: linear;
			animation-iteration-count: 1;
			animation-fill-mode: forwards;
		}
	}

	@keyframes advert {
		from {
			transform: translateY(10px);
			opacity: 0;
		}

		to {
			transform: translateY(0);
			opacity: 1;
		}
	}

	.bottom {
		margin-top: 12px;
		display: flex;
		justify-content: space-between;

		.btn-group span {
			margin: 0 5px;
			cursor: pointer;
		}

		.btn-group span:last-child {
			margin-right: 0;
		}

		.el-icon-edit {
			color: #409eff;
		}

		.el-icon-delete {
			color: #f56c6c;
		}
	}

	.image-slot {
		text-align: center;
		width: 100%;
		height: 260px;
		line-height: 260px;
	}

	.video-js {
		width: 120px !important;
		height: 100px !important;
	}

	.video-js .vjs-big-play-button {
		font-size: 3em;
		line-height: 42px !important;
		height: 50px !important;
		width: 50px !important;
		display: block;
		position: absolute !important;
		left: 50% !important;
		top: 50% !important;
		margin-top: -25px !important;
		margin-left: -25px !important;
		padding: 0;
		cursor: pointer;
		opacity: 1;
		border: 0.06666em solid #fff;
		background-color: #2b333f;
		background-color: rgba(43, 51, 63, 0.7);
		border-radius: 50% !important;
		-webkit-transition: all 0.4s;
		transition: all 0.4s;
	}

	.vjs-paused .vjs-big-play-button,
	.vjs-paused.vjs-has-started .vjs-big-play-button {
		display: block !important;
	}

	.myVideo-dimensions {
		width: 100% !important;
		height: 100% !important;
		display: block !important;
	}

	.vjs-poster {
		background-size: 100% 100% !important;
	}
}
</style>
